export default __webpack_public_path__ + "static/media/manchester_city_logo.6285657d.png";